export var BusinessFeatureType;
(function (BusinessFeatureType) {
    BusinessFeatureType["Root"] = "ROOT";
    BusinessFeatureType["TransactionType"] = "TRANSACTION_TYPE";
    BusinessFeatureType["FromCurrency"] = "FROM_CURRENCY";
    BusinessFeatureType["ToCurrency"] = "TO_CURRENCY";
    BusinessFeatureType["FromCountry"] = "FROM_COUNTRY";
    BusinessFeatureType["ToCountry"] = "TO_COUNTRY";
    BusinessFeatureType["FromChannel"] = "FROM_CHANNEL";
    BusinessFeatureType["ToChannel"] = "TO_CHANNEL";
})(BusinessFeatureType || (BusinessFeatureType = {}));
//# sourceMappingURL=AfriexBusiness.js.map